<template>
    <b-modal
        v-model="modalOpened"
        modal-class="volver-comprar-modal"
        title="Volver a comprar"
        centered
    >
        <template v-slot:modal-footer>
            <button
                v-if="stock > 0"
                class="btn ok-btn"
                :disabled="disableComprar"
                @click="addCart"
            >
                <b-spinner small v-if="saving"></b-spinner> Añadir al carrito
            </button>
            <button
                class="btn cancel-btn"
                @click="modalOpened = false"
                :disabled="saving"
            >
                Cancelar
            </button>
        </template>

        <div id="section_product_detail">
            <div class="block_right_product">
                <div id="main-container-details" class="p-2">
                    <h1>
                        <template v-if="eco">
                            ECO
                        </template>
                        {{ articulo.especie_verify.nombre }}
                        <br />
                        <span style="font-size: 19px">{{
                            articulo.nombre_verify
                        }}</span>
                    </h1>
                    <load-spiner v-if="loadingInfo"></load-spiner>
                    <div v-else>
                        <div v-if="stock > 0">
                            <p class="precio_minimo_garantizado">
                                <img
                                    src="/img/iconos/icon_precio_minimo_garantizado.svg"
                                />
                                Precio mínimo garantizado
                                <i
                                    v-b-modal.modal-preciominimo
                                    class="fa fa-info-circle cursor_pointer"
                                ></i>
                            </p>

                            <div class="mb-2" style="color: #4e4e4e">
                                <span>Precio bandeja</span>
                                <span class="price" v-if="!inOferta">
                                    {{ precio | round }} €
                                    <small>IVA incluido</small>
                                </span>
                                <span class="price_oferta" v-else>
                                    <span class="last"
                                        >{{ precio | round }} €</span
                                    >
                                    <span class="new"
                                        >{{ precio_oferta | round }} €</span
                                    >
                                    <small>IVA incluido</small>
                                </span>

                                <br />

                                <span>Precio total</span>
                                <span class="price" v-if="!inOferta">
                                    {{
                                        (precio * cantidad)
                                            | getAhorro(cantidad, true)
                                            | round
                                    }}
                                    €
                                    <small>IVA incluido</small>
                                </span>
                                <span class="price_oferta" v-else>
                                    <span class="last"
                                        >{{
                                            (precio * cantidad)
                                                | getAhorro(cantidad, true)
                                                | round
                                        }}
                                        €</span
                                    >
                                    <span class="new"
                                        >{{
                                            (precio_oferta * cantidad)
                                                | getAhorro(cantidad, true)
                                                | round
                                        }}
                                        €</span
                                    >
                                    <small>IVA incluido</small>
                                </span>
                            </div>

                            <div class="selectores container">
                                <load-spiner v-if="!weeks"></load-spiner>
                                <div class="row select_item mb-1" v-else>
                                    <div class="col-7 title">
                                        Semana de entrega
                                    </div>
                                    <div
                                        class="col-5 content align-self-center pl-0"
                                    >
                                        <select2
                                            name="week"
                                            v-model="addWeek"
                                            :config-options="{
                                                minimumResultsForSearch: Infinity
                                            }"
                                        >
                                            <option
                                                v-for="(week, add) in weeks"
                                                :key="add"
                                                :value="add"
                                            >
                                                Semana
                                                {{ parseInt("" + week[1]) }}
                                            </option>
                                        </select2>
                                    </div>
                                </div>
                                <div class="row select_item mb-1">
                                    <div class="col-7 title">
                                        Nº Alvéolos por bandeja
                                    </div>
                                    <div
                                        class="col-5 content align-self-end pl-0"
                                    >
                                        <select2
                                            v-if="bandejas.length > 1"
                                            name="combinacion"
                                            v-model="select_bandeja"
                                            :config-options="{
                                                minimumResultsForSearch: Infinity
                                            }"
                                        >
                                            <option
                                                v-for="bandeja in bandejas"
                                                :key="bandeja"
                                                :value="bandeja"
                                            >
                                                {{ bandeja }}
                                            </option>
                                        </select2>
                                        <select2
                                            v-else
                                            name="combinacion"
                                            v-model="select_bandeja"
                                            :config-options="{
                                                minimumResultsForSearch: Infinity
                                            }"
                                            disabled
                                        >
                                            <option
                                                v-for="bandeja in bandejas"
                                                :key="bandeja"
                                                :value="bandeja"
                                            >
                                                {{ bandeja }}
                                            </option>
                                        </select2>
                                    </div>
                                </div>
                                <div class="row select_item mb-1">
                                    <div class="col-7 title">
                                        Nº semillas por alvéolo
                                    </div>
                                    <div
                                        class="col-5 content align-self-baseline pl-0"
                                    >
                                        <select2
                                            v-if="semillas.length > 1"
                                            name="semillas_alveolo"
                                            @change="setData()"
                                            v-model="select_semillas"
                                            :config-options="{
                                                minimumResultsForSearch: Infinity
                                            }"
                                        >
                                            <option
                                                v-for="combinacion in semillas"
                                                :key="
                                                    combinacion.semilla_alveolo
                                                "
                                                :value="
                                                    combinacion.semilla_alveolo
                                                "
                                            >
                                                {{
                                                    combinacion.semilla_alveolo
                                                }}
                                            </option>
                                        </select2>
                                        <select2
                                            v-else
                                            name="semillas_alveolo"
                                            @change="setData()"
                                            v-model="select_semillas"
                                            :config-options="{
                                                minimumResultsForSearch: Infinity
                                            }"
                                            disabled
                                        >
                                            <option
                                                v-for="combinacion in semillas"
                                                :key="
                                                    combinacion.semilla_alveolo
                                                "
                                                :value="
                                                    combinacion.semilla_alveolo
                                                "
                                            >
                                                {{
                                                    combinacion.semilla_alveolo
                                                }}
                                            </option>
                                        </select2>
                                    </div>
                                </div>
                            </div>
                            <br />

                            <div
                                v-if="this.articulo.average_valoracion !== null"
                                class="star-rating-wrapper"
                            >
                                <star-rating
                                    :read-only="true"
                                    :rating="this.articulo.average_valoracion"
                                    :show-rating="false"
                                    :star-size="20"
                                ></star-rating>
                                <b>({{ this.articulo.num_valoracion }})</b>
                            </div>

                            <br />

                            <div
                                v-if="stock >= 3"
                                :class="'ahorro_block row ' + ahorro_block"
                            >
                                <div
                                    class="title_block col-9"
                                    v-show="cantidad >= 3"
                                >
                                    <span>Está ahorrando</span>
                                </div>
                                <div
                                    class="title_block col-3"
                                    v-show="cantidad >= 3"
                                >
                                    <span
                                        >{{
                                            ahorro
                                                | getAhorro(cantidad)
                                                | round
                                        }}€</span
                                    >
                                </div>
                                <div class="title_block col-9">
                                    <span>Descuento por volumen</span>
                                </div>
                                <div class="title_block col-3">
                                    <!--<i :class="'fas fa-signal ahorro '+ahorro_icon"></i>-->
                                    <img
                                        class="ahorro_icon"
                                        :src="
                                            '/img/iconos/icon_descuento' +
                                                ahorro_icon +
                                                '_azul.svg'
                                        "
                                    />
                                    <i
                                        class="fas fa-info-circle cursor_pointer"
                                        @click="
                                            openInfoWindow('info_descuento')
                                        "
                                    ></i>
                                    <windows-info
                                        v-cloak
                                        ref="info_descuento"
                                        back-color="green"
                                        in-product="true"
                                    >
                                        <span slot="header">
                                            Se aplicarán los siguientes
                                            descuentos por volumen de compra
                                            siempre que se trate de un mismo
                                            artículo.
                                        </span>
                                        <span slot="footer">
                                            <strong>De 3 a 6 bandejas</strong
                                            ><br />
                                            <span
                                                >Descuento de 0,33€ por
                                                bandeja</span
                                            >
                                            <br /><br />
                                            <strong>De 7 a 11 bandejas</strong
                                            ><br />
                                            <span
                                                >Descuento de 0,66€ por
                                                bandeja</span
                                            >
                                            <br /><br />
                                            <strong>Más de 12 bandejas</strong
                                            ><br />
                                            <span
                                                >Descuento de 1,00€ por
                                                bandeja</span
                                            >
                                        </span>
                                    </windows-info>
                                </div>
                            </div>
                            <br />
                            <div class="unidades container">
                                <div class="row select_item">
                                    <div class="col-lg-8 col-md-6 col-7 title">
                                        Cantidad
                                    </div>
                                    <div
                                        class="col-lg-4 col-md-6 col-5 content"
                                    >
                                        <span
                                            class="control"
                                            @click="minusUnits()"
                                            >-</span
                                        >
                                        <span class="num">{{ cantidad }}</span>
                                        <span
                                            class="control"
                                            @click="
                                                !full_stock ? addUnits() : ''
                                            "
                                            >+</span
                                        >
                                    </div>
                                </div>
                            </div>
                            <div style="position: relative;">
                                <windows-info
                                    v-cloak
                                    ref="info_ayuda_form_more"
                                    back-color="red"
                                    in-product="true"
                                    :articulo="articulo"
                                    :combinacion="combinacion_selected"
                                >
                                    <div slot="header">
                                        <h4 class="title">
                                            ¿Necesitas más de esta variedad?
                                        </h4>
                                        <h4 class="title_alt">¡Contáctanos!</h4>
                                    </div>
                                    <div slot="button">
                                        <a class="alter-btn-green">
                                            <span>
                                                Rellenar formulario
                                            </span>
                                        </a>
                                    </div>
                                    <div slot="agradecimiento">
                                        <div class="py-3 px-1">
                                            <h2 class="title">¡Gracias!</h2>
                                            <h3 class="title_alt">
                                                Recuerda finalizar el proceso si
                                                quieres comprar el disponible de
                                                esta variedad
                                            </h3>
                                        </div>
                                    </div>
                                </windows-info>
                            </div>
                        </div>
                        <div v-else>
                            <windows-info
                                v-cloak
                                ref="info_ayuda_form"
                                back-color="red"
                                :articulo="articulo"
                                defaultbl="true"
                            >
                                <div slot="header">
                                    <h4 class="title">
                                        <template v-if="weeks">
                                            No disponible en la semana
                                            {{ weeks[addWeekSetted][1] }}
                                        </template>
                                        <template v-else>
                                            No disponible
                                        </template>
                                    </h4>
                                    <h4
                                        class="title-alt"
                                        v-if="
                                            semanasDondeHayStockGeneral.length <=
                                                0
                                        "
                                    >
                                        ¿Necesitas de esta variedad?
                                    </h4>
                                </div>
                                <div slot="button">
                                    <a class="alter-btn-green">
                                        <span>
                                            Rellenar formulario
                                        </span>
                                    </a>
                                </div>
                                <div slot="agradecimiento">
                                    <div class="py-3 px-1">
                                        <h2 class="title">¡Gracias!</h2>
                                        <h3 class="title_alt">
                                            Recuerda finalizar el proceso si
                                            quieres comprar el disponible de
                                            esta variedad
                                        </h3>
                                    </div>
                                </div>
                            </windows-info>

                            <h4
                                class="otras-semanas-disponible-title"
                                v-if="semanasDondeHayStockGeneral.length > 0"
                            >
                                Disponemos de stock para
                                {{
                                    semanasDondeHayStockGeneral.length > 1
                                        ? "las semanas"
                                        : "la semana"
                                }}
                                <span>
                                    <template
                                        v-for="(semana,
                                        index) in semanasDondeHayStockGeneral"
                                    >
                                        <a
                                            href="javascript:void(0)"
                                            @click="
                                                seleccionarSemanaNoStock(semana)
                                            "
                                            class="otras-semanas-disponible-semana"
                                        >
                                            {{
                                                parseInt(semana.substring(5))
                                            }} </a
                                        ><span
                                            v-if="
                                                index <
                                                    semanasDondeHayStockGeneral.length -
                                                        2
                                            "
                                            >,
                                        </span>
                                        <span
                                            v-else-if="
                                                index ===
                                                    semanasDondeHayStockGeneral.length -
                                                        2
                                            "
                                        >
                                            y
                                        </span>
                                    </template>
                                </span>
                            </h4>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </b-modal>
</template>

<script>
import { mapGetters } from "vuex";
import StarRating from "vue-star-rating";

export default {
    name: "VolverComprarModal",
    components: {
        StarRating
    },
    props: {
        line: {
            type: Object,
            required: true
        },
        lineType: {
            type: String,
            default: "Disponible",
            validator(val) {
                return ["Disponible", "Medida"].indexOf(val) !== -1;
            }
        },
        showModal: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            saving: false,
            modalOpened: this.showModal,

            loadingInfo: false,

            articulo: this.line.articulo,

            addWeek: 1,
            precio: "999",
            inOferta: false,
            precio_oferta: "999",

            stock: "",
            cantidad: "1",
            full_stock: false,

            stockSemanasGeneral: [],

            bandejas: [],
            semillas: "",
            select_bandeja: "",
            select_semillas: "",
            combinacion_selected: "",

            ahorro: "0",
            ahorro_icon: "",
            ahorro_block: "",
            addWeekSetted: 1
        };
    },
    computed: {
        ...mapGetters("disponible", ["weeks"]),
        disableComprar() {
            return this.saving;
        },
        eco() {
            return !!this.line.ecologico;
        },
        semanasDondeHayStockGeneral() {
            return this.stockSemanasGeneral
                .filter(s => s.stock > 0)
                .map(s => s.year + "-" + s.semana);
        }
    },
    watch: {
        showModal() {
            this.loadInfo();
            this.modalOpened = this.showModal;
        },
        modalOpened(value) {
            this.$emit("update:showModal", value);
        },
        addWeek() {
            this.loadInfo();
        },
        cantidad: function(val) {
            if (val >= 12) {
                this.ahorro_icon = "full";
            } else if (val >= 7) {
                this.ahorro_icon = "medium";
            } else if (val >= 3) {
                this.ahorro_icon = "low";
            } else {
                this.ahorro_icon = "";
            }
            if (val < 3) {
                this.ahorro_block = "disabled";
            } else {
                this.ahorro_block = "";
            }
        },
        select_bandeja: function(val) {
            this.semillas = this.articulo.combinaciones_c.filter(
                x => x.bandeja_id == val
            );

            this.select_semillas = this.semillas[0].semilla_alveolo;

            this.setData();
        }
    },
    methods: {
        loadInfo() {
            this.loadingInfo = true;
            axios
                .get(
                    "/products/" +
                        this.articulo.id +
                        "-" +
                        this.articulo.slug +
                        "/" +
                        this.addWeek +
                        "/" +
                        this.eco
                )
                .then(response => {
                    this.addWeekSetted = this.addWeek;
                    this.articulo = response.data.articulo;
                    this.stockSemanasGeneral =
                        response.data.stockSemanasGeneral;
                    this.loadWeekData();
                })
                .catch(e => {
                    Vue.toasted.show("Ha habido un error!", {
                        type: "error",
                        duration: 3000
                    });
                    console.log(e);
                })
                .finally(() => {
                    this.loadingInfo = false;
                });
        },
        gaAddToCart(quantity) {
            const {
                id,
                nombre,
                especie_verify: { nombre: especieNombre }
            } = this.articulo;
            ga("ec:addProduct", {
                id, // Product ID (string).
                name: nombre, // Product name (string).
                category: especieNombre, // Product category (string).
                brand: "Babyplant", // Product brand (string).
                quantity
                //'variant': 'gray',                  // Product variant (string).
                //'position': 2                       // Product position (number).
            });
            ga("ec:setAction", "add"); // Detail action.
            ga("ec:setAction", "add_to_cart"); // Detail action.
            ga('send', 'event', 'Ecommerce', 'Add to Cart');
        },
        addCart: function() {
            if (this.combinacion_selected) {
                this.saving = true;
                axios
                    .post("/carrito/store", {
                        articulo: this.articulo.id,
                        combinacion: this.combinacion_selected.id,
                        unidades: this.cantidad,
                        addWeek: this.addWeek,
                        eco: this.eco
                    })
                    .then(response => {
                        this.gaAddToCart(this.cantidad);
                        this.$root.$emit("loadCartInfo");
                        Vue.toasted.show("Añadido al carrito", {
                            type: "success",
                            duration: 3000
                        });
                        this.modalOpened = false;
                    })
                    .catch(e => {
                        if (e.response) {
                            if (e.response.data) {
                                if (
                                    e.response.data.info ===
                                    "No hay stock suficiente."
                                ) {
                                    this.openInfoWindow("info_ayuda_form_more");
                                    this.full_stock = true;
                                } else {
                                    Vue.toasted.show(
                                        e.response.data.info
                                            ? e.response.data.info
                                            : "Ha habido un error!",
                                        {
                                            type: "error",
                                            duration: 3000
                                        }
                                    );
                                }
                                return null;
                            }
                        }
                        Vue.toasted.show("Ha ocurrido un error", {
                            type: "error",
                            duration: 3000
                        });
                        console.error(e);
                    })
                    .finally(() => {
                        this.saving = false;
                    });
            } else {
                Vue.toasted.show("Selecciona un formato", {
                    type: "error",
                    duration: 3000
                });
            }
        },
        addUnits: function() {
            if (this.stock) {
                if (this.cantidad < this.stock) {
                    this.cantidad++;
                } else {
                    this.openInfoWindow("info_ayuda_form_more");
                    this.full_stock = true;
                }
            } else {
                Vue.toasted.show("Selecciona un formato", {
                    type: "error",
                    duration: 3000
                });
            }
        },
        minusUnits: function() {
            if (this.cantidad > 1) {
                this.cantidad--;
                this.full_stock = false;
            }
        },
        setData: function(combinacion = "") {
            if (combinacion) {
                this.combinacion_selected = combinacion;
                this.select_bandeja = this.combinacion_selected.bandeja_id;
                this.select_semillas = this.combinacion_selected.semilla_alveolo;
            } else {
                this.combinacion_selected = this.articulo.combinaciones_c.find(
                    x =>
                        x.bandeja_id == this.select_bandeja &&
                        x.semilla_alveolo == this.select_semillas
                );
            }

            this.full_stock = false;
            this.cantidad = 1;
            this.inOferta = this.combinacion_selected.precios[0].oferta > 0;
            this.precio = this.combinacion_selected.precios[0].precio_final_iva;

            if (this.inOferta) {
                var discount =
                    (this.precio *
                        this.combinacion_selected.precios[0].oferta) /
                    100;
                this.precio_oferta = this.precio - discount;
            }

            this.stock = _.sumBy(this.combinacion_selected.partidas_c, function(
                partida
            ) {
                return partida.stock;
            });
        },
        openInfoWindow: function(ventana) {
            var window = this.$refs[ventana];
            window.active = !window.active;
        },
        loadWeekData: function() {
            this.precio = "999";
            this.bandejas = [];
            this.stock = 0;
            this.full_stock = false;

            if (this.articulo.combinaciones_c) {
                this.bandejas = [
                    ...new Set(
                        this.articulo.combinaciones_c.map(
                            item => item.bandeja_id
                        )
                    )
                ];

                for (var i = 0; i < this.articulo.combinaciones_c.length; i++) {
                    if (
                        this.precio >
                        this.articulo.combinaciones_c[i].precios[0]
                            .precio_final_iva
                    ) {
                        this.setData(this.articulo.combinaciones_c[i]);
                    }
                    if (
                        !this.bandejas.indexOf(
                            this.articulo.combinaciones_c.bandeja_id
                        )
                    ) {
                        this.bandejas.push(
                            this.articulo.combinaciones_c.bandeja_id
                        );
                    }
                }
            }
        },
        seleccionarSemanaNoStock(yearWeek) {
            let year = parseInt(yearWeek.substring(0, 4));
            let semana = parseInt(yearWeek.substring(5));
            for (const [key, value] of Object.entries(this.weeks)) {
                if (
                    parseInt("" + value[0]) === year &&
                    parseInt("" + value[1]) === semana
                ) {
                    this.addWeek = key;
                    break;
                }
            }
        }
    },
    created() {
        if (this.showModal) {
            this.loadInfo();
        }
    }
};
</script>

<style scoped>
.otras-semanas-disponible-title {
    text-align: center;
    font-weight: bold;
    margin-top: 1rem;
}

.otras-semanas-disponible-semana {
    color: #0871b8;
}
</style>

<style>
.volver-comprar-modal .modal-dialog {
    max-width: 380px;
}

.volver-comprar-modal .modal-header {
    background: #0871b8;
    color: white;
    border-radius: 0;
    padding: 0.5rem 1rem;
}

.volver-comprar-modal .modal-header .close {
    color: white;
    text-shadow: none;
    opacity: 1;
}

.volver-comprar-modal .modal-footer {
    justify-content: center;
}

.volver-comprar-modal .modal-footer .btn {
    padding: 0.175rem 2rem;
}

.volver-comprar-modal .modal-footer .ok-btn {
    font-size: 17px;
    font-weight: bold;
    padding: 5px 15px;
    margin-top: 10px;
    color: #0071bc;
    background-color: #ffba2a;
    border-color: #0071bc;
    border-width: 2px;
    border-radius: 0;
    margin-bottom: 0.5em;
}

.volver-comprar-modal .modal-footer .ok-btn:hover {
    background-color: #f29020;
}

.volver-comprar-modal .modal-footer .cancel-btn {
    font-size: 17px;
    font-weight: bold;
    padding: 5px 15px;
    margin-top: 10px;
    color: #2d2d2d;
    border-color: #1c1c1c;
    border-width: 2px;
    border-radius: 0;
    margin-bottom: 0.5em;
    margin-right: 0.7em;
}

.volver-comprar-modal .modal-footer .ok-btn:disabled,
.volver-comprar-modal .modal-footer .cancel-btn:disabled {
    background-color: #b4b3b3;
    color: #808081;
    border-color: #808081;
    opacity: 1;
}

.volver-comprar-modal #section_product_detail {
    margin-top: 0;
}

.volver-comprar-modal #section_product_detail .block_right_product {
    border: 0;
}
</style>
